import { CaretLeftFill, CaretDownFill, DistributeVertical, DistributeHorizontal } from 'react-bootstrap-icons';
import { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
const MenuItem = (props) => {
    const { title, items, level2, style, className, initHeight } = props;
    const [subMenuDisplay, setSubMenuDisplay] = useState(initHeight ?? "0");
    const menuClick = (e) => {
        let d = subMenuDisplay === "0" ? "500px" : "0";
        setSubMenuDisplay(d);
    }
    return (
        <div className={"menuItem" + (level2 ? " menuItemL2" : "") + (className ? " " + className : "")} >
            {level2 &&
                <Fragment>
                    {subMenuDisplay === "0" && <CaretLeftFill/>}
                    {subMenuDisplay === "500px" && <CaretDownFill />}
                </Fragment>
            }
            {!level2 &&
                <Fragment>
                    {subMenuDisplay === "0" && <DistributeVertical color='#451a95' />}
                    {subMenuDisplay === "500px" && <DistributeHorizontal color='#451a95' />}
                </Fragment>
            }
            <span className={level2 ? "menuTitleL2" : 'menuTitle'} onClick={menuClick}>{title}</span>
            <div className='subMenu' style={{ ...style, marginTop: level2 ? "5px" : "10px", marginBottom: level2 ? "4px" : "8px", maxHeight: subMenuDisplay }}>
                {items && Array.isArray(items) && items.map((item, i) => {
                    return (
                        <Fragment key={i}>
                            {item.type === "a" &&
                                <a href={item.href} onClick={item.onClick} style={{ marginRight: "10px", marginTop: "2px", display: "block" }}>
                                    {item.icon}
                                    <span style={{ color: "black", fontSize: "13px", marginRight: "8px" }}>{item.text}</span>
                                </a>
                            }
                            {item.type === "link" &&
                                <Link to={{ pathname: item.to, state: null }} onClick={item.onClick} style={{ marginRight: "10px", marginTop: "2px", display: "block" }}>
                                    {item.icon}
                                    <span style={{ color: "black", fontSize: "13px", marginRight: "8px" }}>{item.text}</span>
                                </Link>
                            }
                            {item.type === "space" &&
                                <div style={{ width: "100%", height: "5px" }}>&nbsp;&nbsp;</div>
                            }
                            {item.type === "line" &&
                                <div style={{ width: "100%", marginRight: "18px", marginTop: "2px" }}>---------------------------------</div>
                            }
                            {item.type === "menuItem" &&
                                <MenuItem title={item.title} items={item.subItems} level2={true} style={item.style} className={item.className} />
                            }

                        </Fragment>)

                })}
            </div>
        </div>)
}
export default MenuItem;